/**
 * Sessão 33 (Phase β) — Minimal operator observation telemetry.
 *
 * Fire-and-forget. Silent failure. NEVER blocks UI.
 * 4 event types only: tab_opened, filter_changed, why_opened, suggestion_action.
 *
 * Per user constraint: "extremely lightweight and temporary".
 * No queue, no batching, no retry — just a quick POST. If it fails, we lose
 * the event (acceptable: we have 100s/day, not 1000s/sec).
 *
 * Backend auto-expires events after 30 days (TTL index).
 */
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export function trackEvent(eventType, context = {}) {
  try {
    const token = localStorage.getItem('token');
    if (!token) return;
    // Fire and forget — silent failure
    axios
      .post(
        `${API}/telemetry/event`,
        { event_type: eventType, context },
        { headers: { Authorization: `Bearer ${token}` }, timeout: 3000 }
      )
      .catch(() => {});
  } catch (e) {
    // Never let telemetry break the UI.
    console.debug('telemetry failed:', e);
  }
}

export default trackEvent;
